"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var auth_settings_config_1 = require("../auth-settings.config");
function addToken(request, cookieService) {
    var accessToken = cookieService.get(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME);
    if (accessToken) {
        return request.clone({
            setHeaders: {
                Authorization: "Bearer " + accessToken,
            },
        });
    }
    var csrfToken = localStorage.getItem(auth_settings_config_1.AuthSettings.CSRF_TOKEN_KEY_NAME);
    if (csrfToken) {
        return request.clone({
            setHeaders: {
                'X-XSRF-TOKEN': csrfToken,
            },
        });
    }
    return request;
}
exports.addToken = addToken;
function isProductionMode() {
    var uiOptions = window['uiOptions']
        ? window['uiOptions']
        : document['uiOptions']
            ? document['uiOptions']
            : undefined;
    return uiOptions !== undefined && uiOptions['productionMode'];
}
exports.isProductionMode = isProductionMode;
//# sourceMappingURL=token.utilities.js.map